import COMMON_EMAIL_DOMAINS from 'constants/commonDomains';

import parseDomain from './parseDomain';

const isBusinessEmail = (email: string): boolean => {
  if (!email) {
    return false;
  }
  const emailDomain = parseDomain(email);

  return !COMMON_EMAIL_DOMAINS.includes(emailDomain);
};

export default isBusinessEmail;
